/**
 * A máscara do "olhinho" (pedido de 09/10/2026): número escondido vira "••••"
 * e o que está em volta fica — "R$ ••••", "•••• cotas", "••••%".
 *
 * Só se aplica a texto que É número formatado (o retorno de formatCurrency,
 * um contador, um percentual). Nunca à tela inteira: data, CPF, telefone,
 * contrato e cota também têm dígitos e precisam continuar legíveis. Quem
 * monta uma frase com número E data mascara só o pedaço do número.
 *
 * O sinal vai junto com o número ("+3,4%" → "••••%"): "+" e "−" já contam
 * se subiu ou caiu.
 */

export const MASCARA = '••••';

// Sinal opcional + dígitos com separador de milhar/decimal no meio. Espaço não
// entra: "12 vendas" é um número seguido de palavra, não "12 v...".
const NUMERO = /[+\-−]?\d(?:[\d.,]*\d)?/g;

// Sinal ANTES do "R$" ("-R$ 56,78", como o Intl formata negativo): também
// conta se é perda ou ganho, então sai junto.
const SINAL_DA_MOEDA = /[+\-−](?=\s?R\$)/g;

export const mascarar = (texto: string | number | null | undefined): string => {
  if (texto === null || texto === undefined) return '';
  return String(texto).replace(SINAL_DA_MOEDA, '').replace(NUMERO, MASCARA);
};

/** A função que as telas usam: mascara se estiver oculto, senão devolve igual. */
export type Mascara = (texto: string | number | null | undefined) => string;

export const criarMascara = (oculto: boolean): Mascara =>
  oculto
    ? mascarar
    : (texto) => (texto === null || texto === undefined ? '' : String(texto));
